import request from '@/utils/request'

// 查询企业工作室科技交流列表
export function listYwKjjl(query) {
  return request({
    url: '/web/fwjg/ywKjjl/list',
    method: 'get',
    params: query
  })
}

// 查询企业工作室科技交流详细
export function getYwKjjl(recid) {
  return request({
    url: '/web/fwjg/ywKjjl/' + recid,
    method: 'get'
  })
}

// 新增企业工作室科技交流
export function addYwKjjl(data) {
  return request({
    url: '/web/fwjg/ywKjjl',
    method: 'post',
    data: data
  })
}

// 修改企业工作室科技交流
export function updateYwKjjl(data) {
  return request({
    url: '/web/fwjg/ywKjjl/edit',

    method: 'post',
    data: data
  })
}

// 删除企业工作室科技交流
export function delYwKjjl(recid) {
  return request({
    url: '/web/fwjg/ywKjjl/remove/' + recid,

    method: 'post',
  })
}

// 导出企业工作室科技交流
export function exportYwKjjl(query) {
  return request({
    url: '/web/fwjg/ywKjjl/export',
    method: 'get',
    params: query
  })
}